import services from "@/composable/services";
import { ApplicationResult, Node } from "@/types/generated/UsedGeneratedTypes";

/**
 * Récursivement, retourne la liste de tous les noms de node du sous-graphe.
 */
export function allDataName(node: Node, nodeNames: string[]): string[] {
  const level = (node as any).level;
  const hasChildren = Array.isArray(node.children) && node.children.length !== 0;

  // Règle issue des tests:
  // - Si level === 0 et il y a des enfants → ne pas ajouter le nom du noeud racine
  // - Si level === 0 et SANS enfants → ajouter le nom (cas feuille)
  // - Sinon (level !== 0) → ajouter le nom s'il existe
  if (node.nodeName) {
    if (level === 0) {
      if (!hasChildren) nodeNames.push(node.nodeName);
    }
    else {
      nodeNames.push(node.nodeName);
    }
  }
  if (hasChildren) {
    for (const localChild of node.children) {
      allDataName(localChild, nodeNames);
    }
  }
  return nodeNames;
}

/**
 * Construit un objet withScope/withoutScope pour utilisation dans l’UI ("listDataNodeNames" = string[])
 */
export function createListData(
  listDataNodeNames: string[],
  application: ApplicationResult,
): {
  withScope: Record<string, { id: string; name: string }>;
  withoutScope: Record<string, { id: string; name: string }>;
} {
  return {
    withScope: listDataNodeNames
      .filter(name => application.configuration.dataDescription[name].authorization)
      .reduce<Record<string, { id: string; name: string }>>((acc, data) => {
        acc[data] = {
          id: data,
          name:
                        services.internationalisationService.localeReferenceNames(data, application) || data,
        };
        return acc;
      }, {}),
    withoutScope: listDataNodeNames
      .filter(name => application.configuration.dataDescription[name].authorization === null)
      .reduce<Record<string, { id: string; name: string }>>((acc, data) => {
        acc[data] = {
          id: data,
          name:
                        services.internationalisationService.localeReferenceNames(data, application) || data,
        };
        return acc;
      }, {}),
  };
}
